import React from 'react';
import './ImagePreview.css';

const ImagePreview = ({ imageUrl, alt = "Preview Target" }) => {
  if (!imageUrl) return null;

  return (
    <div className="image-preview-content">
      <img
        src={imageUrl}
        alt={alt}
        className="preview-img"
      />
    </div>
  );
};

export default ImagePreview;